import React, { useMemo } from "react"
import { StyleSheet, View } from "react-native"
import { Switch } from "react-native-switch"
import { useMediaQuery } from "react-responsive"

import Base from "../../base"

export default function CustomSwitch({
  value,
  onValueChange,
  small,
  autoWidth,
  style,
  hidden = false,
}) {
  const isMobile = useMediaQuery(Base.constants.mobile)

  const switchSize = useMemo(
    () => ({
      barHeight: small ? 24 : 32,
      circleSize: small ? 16 : 24,
      circleBorderWidth: 0,
      switchBorderRadius: small ? 12 : 15.5,
      switchWidthMultiplier: small ? 2.625 : 2.125,
      switchLeftPx: small ? 5 : 4,
      switchRightPx: small ? 5 : 4,
    }),
    [small],
  )

  return (
    <View
      style={[
        styles.main,
        isMobile && styles.main_sm,
        autoWidth && styles.autoWidth,
        style,
      ]}
    >
      {!hidden && (
        <Switch
          value={value}
          onValueChange={onValueChange}
          activeText=""
          inActiveText=""
          backgroundActive={Base.colours.appGreen}
          backgroundInactive={Base.colours.appGrey}
          {...switchSize}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    alignItems: "center",
    width: 130,
  },
  main_sm: {
    width: 90,
  },
  autoWidth: {
    width: "auto",
  },
})
